const accordions = document.querySelectorAll('.accordion-tabs');
accordions.forEach(accordion => {
    const accordionLabels = accordion.querySelectorAll('.accordion-tabs__label');

    accordionLabels.forEach(label => {
        label.addEventListener('click', () => {
            const accordionIsOpen = label.getAttribute('aria-selected');

            accordionLabels.forEach(e => {
                if (window.innerWidth > 960) {
                    e.setAttribute('aria-selected', 'false');
                }

                e.setAttribute('data-open', 'false');
            });

            if (accordionIsOpen == 'true' && window.innerWidth <= 960) {
                label.setAttribute('aria-selected', 'false');
                label.setAttribute('data-open', 'false');
            } else {
                label.setAttribute('aria-selected', 'true');
                label.setAttribute('data-open', 'true');
            }
        });
    });
});
